import { notifications } from 'ionicons/icons';
import { chevronDownOutline } from 'ionicons/icons';
import { chevronBackOutline } from 'ionicons/icons';
import { addIcons } from 'ionicons';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NotificationType } from '@v-locker-app/v-locker-common/lib/shared/alerts/alert.model';
import { combineLatest, interval, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { NotificationDto, NotificationOptionDto } from 'src/app/api/models';
import { UserProfileApiService, UserBookingsApiService, UserNewsApiService } from 'src/app/api/services';
import { OrdersService } from 'src/app/msp-api/services';
import { CustomSpinnerService } from 'src/shared/services/helpers/custom-spinner.service';
import { EventsService } from 'src/shared/services/helpers/events.service';
import { PushNotificationHelperService } from 'src/shared/services/helpers/push-notification-helper.service';
import { IonButtons, IonPopover, IonBadge, IonIcon, IonContent, IonItem, IonList, IonLabel, IonButton, IonToggle, AlertController } from "@ionic/angular/standalone";
import { IconComponent } from "../icon/icon.component";
import { ContextHelpComponent } from "../../context-help/context-help.component";
import { NgFor, NgIf } from '@angular/common';

export interface CustomNotificationDTO extends NotificationDto {
	groupDate: string;
	dateTitle: string;
	name: string;
	clazz: string;
}

enum NotificationTypes {
	"MANUAL" = "notifications-types.admin-message",
	"NEWS" = "notifications-types.news",
	"BOX_IS_OPEN_TOO_LONG" = "notifications-types.box-status",
	"BOOKING_IS_OPEN_TOO_LONG" = "notifications-types.booking-status",
	"SUBSCRIPTION_EXPIRE_SOON" = "notifications-types.subscription-status",
	"SUBSCRIPTION_WITH_BOOKINGS_EXPIRE_SOON" = "notifications-types.sub-expire-soon",
	"MSP_ORDER" = "notifications-types.order-status"
}

enum NotificationTypesDescription {
	"BOX_IS_OPEN_TOO_LONG" = "notifications-types.description.box",
	"BOOKING_IS_OPEN_TOO_LONG" = "notifications-types.description.booking",
}

export interface GroupedNotification {
	name: string;
	list: Array<CustomNotificationDTO>;
}

@Component({
	selector: 'vl-notifications',
	templateUrl: './notifications.component.html',
	styleUrls: ['./notifications.component.scss'],
	imports: [NgIf, NgFor, IonToggle, IonButton, IonLabel, IonList, IonItem, IonContent, IonIcon, IonBadge, IonPopover, IonButtons, TranslatePipe, IconComponent, ContextHelpComponent],
})

export class NotificationsComponent implements OnInit, OnDestroy {

public notifications: Array<CustomNotificationDTO> = [];
public notifications2: Array<CustomNotificationDTO> = [];

private notifier: Subject<any> = new Subject<any>();
private readonly pageSize = 5;
private page = 0;
public notifyMeSwitcher = false;
public ready = false;
public showViewMore: boolean = true;
public currentType: 'List' | 'Settings' = 'List';
public loading = true;
public notificationsCount: number;
public notificationsOptions: NotificationOptionDto[];
public notificationTypes = NotificationTypes;
public notificationTypesDescription = NotificationTypesDescription;
public isToggleChecked: boolean = false;
public notificationMethods = {
	'EMAIL': {
		label: 'notifications-types.email',
		value: 'EMAIL',
	},
	'ONE_SIGNAL_PUSH': {
		label: 'notifications-types.push',
		value: 'ONE_SIGNAL_PUSH',
	}
};
methods: any[] = [];
constructor(
	private userService: UserProfileApiService,
	private loader: CustomSpinnerService,
	private bookingService: UserBookingsApiService,
	private newsService: UserNewsApiService,
	private alertCtrl: AlertController,
	private translate: TranslateService,
	private eventsService: EventsService,
	private ordersService: OrdersService,
	private userProfile: UserProfileApiService,
	private cd: ChangeDetectorRef,
	private pushNotificationHelperService: PushNotificationHelperService
) {
    addIcons({ notifications, chevronDownOutline, chevronBackOutline });
}

ngOnInit() {
	this.loadUnreadCount();
	interval(15000).pipe(takeUntil(this.notifier)).subscribe(() => {
		this.loadUnreadCount();
	});
	this.eventsService.$openNotificationSettingsObs.pipe(takeUntil(this.notifier)).subscribe(() => {
		const notifBtn = document.getElementById('open-notifications');
		if (notifBtn) {
			notifBtn.click();
			this.goToSettings();
		}
	});
}


ionViewDidLeave() {
	this.notifier.next('');
	this.notifier.complete();
}

ngOnDestroy(): void {
	this.notifier.next('');
	this.notifier.complete();
}

loadData(event = null) {
	this.loadNotifications(event);
}

openModal() {
	this.loadNotifications();
	this.loadUnreadCount();
}

loadUnreadCount() {
	this.userProfile.getNotificationsUnreadCount().pipe(take(1)).subscribe(v => this.notificationsCount = v.value);
}

loadNotifications(event = null, resetPage = false) {
	this.loading = true;
	this.currentType = 'List';
	if (resetPage) {
		this.page = 0;
		this.notifications = [];
	}
	this.userService.getAllNotifications({
		page: this.page,
		pageSize: this.pageSize
	}).subscribe((r) => {
		this.page++;
		const elements: Array<any> = r.elements;
		this.notifications = [...this.notifications, ...elements];
		this.notifications2 = this.pushNotificationHelperService.groupNotificationsByDate(
			this.notifications.map(n => {
					return {
						...n,
						...{ groupDate: null }
					} as CustomNotificationDTO;
				}
			)
		);
		this.showViewMore = r.total > this.notifications.length;
		if (event) {
			event.target.complete();
		}
		this.loading = false;
		this.cd.detectChanges();
		this.loader.hide();
	});
}

postTrackBy(index: number, n) {
    return n.id;
}

private async checkStatusRequest(bookingId, onDone) {
	let isBookingActiveAndDoorOpened = false;
	if (!bookingId) {
		return onDone(false);
	}

	await this.loader.show();
	this.bookingService.getBookingTowerInfo({ bookingId })
		.subscribe(t => {
			if (t.status === 'OPEN') {
				this.bookingService.getUserActiveBookings({
					bookingId
				}).subscribe(b => {
					isBookingActiveAndDoorOpened = b.status === 'IN_USE';
					onDone(isBookingActiveAndDoorOpened);
				});
			} else {
				onDone(isBookingActiveAndDoorOpened);
			}

			this.loader.hide();
		}, error => {
			this.loader.hide();
		}
	);
}

goToSettings() {
	this.currentType = 'Settings';
	this.getSettings();
}


async showDetails(n: NotificationDto, innerIndex) {
	if(!n.id) {
		return;
	}
	const openAlert = (showContinueBtn) => this.pushNotificationHelperService.showAlert(
		n.title,
		n.message,
		n.type as NotificationType,
		n.referenceId,
		true,
		showContinueBtn
	);
	console.log(n);

	switch (n.type) {
		case 'BOOKING_IS_OPEN_TOO_LONG':
			openAlert(false);
			break;
		case 'BOX_IS_OPEN_TOO_LONG':
			this.checkStatusRequest(n.referenceId, (b) => {
				openAlert(b);
			});
			break;
		case 'MANUAL':        
			openAlert(false);
			break;
		case 'NEWS':
			this.checkNews(n.referenceId, (b) => {
				openAlert(b);
			});
			break;
		case 'MSP_ORDER':
			this.checkOrder(n.referenceId, (b) => {
				openAlert(b);
			});
			break;
	}

	this.setRead(n, innerIndex);
}


private async checkNews(id, onDone) {
	await this.loader.show();
	this.newsService.getNews({
		id
	}).subscribe(n => {
		if (n && n.id) {
			onDone(true);
		}
		this.loader.hide();
	}, error => {
		onDone(false);
		this.loader.hide();
	});
}

private async checkOrder(id, onDone) {
	await this.loader.show();
	this.ordersService.ordersRetrieve({id})
	.subscribe(n => {
		if (n && n.id) {
			onDone(true);
		}
		this.loader.hide();
	}, error => {
		onDone(false);
		this.loader.hide();
	});
}

async doRefresh(event) {
	console.log('doRefresh');
	await this.loader.show();
	this.notifications = [];
	this.loadNotifications(event, true);
}

async markAllAsRead() {
	await this.loader.show();
	this.userService.markNotificationsRead().subscribe(async () => {
		this.loadUnreadCount();
		this.loadNotifications(null, true);
		await this.loader.hide();
	}, async () => {
		await this.loader.hide();
	});
}

setRead(n: NotificationDto, innerIndex) {
	if (n.status === 'READ') {
		return;
	}
	this.userService.markNotificationRead({
		id: (n.id as unknown as string)
	}).subscribe(() => {
		this.notifications2[innerIndex].status = 'READ';
		this.notifications2[innerIndex].clazz = 'read';
		this.notifications.find(v => v.id === n.id).status = 'READ';
		this.notifications.find(v => v.id === n.id).clazz = 'READ';
		this.notificationsCount = this.notificationsCount - 1;
		this.cd.detectChanges();
	});
}

public resetPagination() {
	this.page = 0;
	this.notifications = [];
	this.notifications2 = [];
}

back() {
	this.currentType = 'List';
}

async showAlert() {
	const alert = await this.alertCtrl.create({
		header: this.translate.instant('alerts.attention'),
		message: this.translate.instant('notifications.one-method'),
		mode: 'ios',
		buttons: [
			{
				text: this.translate.instant('buttons.ok'),
			}
		]
	})
	await alert.present();
}

async update(notification: NotificationOptionDto, m: any, toggle: IonToggle) {
	if(!this.isToggleChecked) {
		this.isToggleChecked = true;
		let methods = [...notification.methods as NotificationOptionDto["methods"]];
		
		if(methods.includes(m)) {
			methods = methods.filter(v => v !== m);
		} else {
			methods.push(m);
		}
		
		if(notification.mandatory && !methods.length) {
			toggle.disabled = true;
			toggle.checked = true;
			this.cd.detectChanges();
			this.showAlert();
		}
		else {
			this.updateNotification(notification.id, methods);
		}
		this.isToggleChecked = false;
		toggle.disabled = false;
	}

}

updateNotification(id: number, methods: NotificationOptionDto["methods"]) {
	this.loader.show();
	this.userService.updateUserNotificationOption({id, body: {methods}}).subscribe(async (n)=> {
		this.notificationsOptions.find(v => v.id === n.id).methods = n.methods;
		this.cd.detectChanges();
		await this.loader.hide();
	});
}

getSettings() {
	this.loader.show();
	combineLatest([this.userService.getNotificationOptions(), this.userService.getNotificationMethods()]).subscribe(([notifications, methods]) => {
			this.notificationsOptions = notifications.filter(v => v.type !== 'MSP_ORDER');
			this.methods = [];
			for(let m of methods.value) {
				this.methods.push({label: this.notificationMethods[m]?.label || m, value: m});
			}
			this.loader.hide();
		});
	}
}
